module.exports = __webpack_public_path__ + "img/1.090eb7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/franchise/bandra/1.jpg
// module id = 127
// module chunks = 1